import { ServiceLocator } from 'src/app/tools/service-locator.tool';
import { CoreService } from 'src/app/services/core.service';
import { DataSourceLike } from 'devextreme/data/data_source';
import { getDataSourceFilteredAndSortedData } from '../helpers/dx-utils';
import dxDataGrid, { Row } from 'devextreme/ui/data_grid';

export class DxDataGridOperator {

	public rowCountText: string;

	private _rowIndex: number = -1;

	private _totalCount: number = -1;
	private _update: boolean = false;

	private _items?: any[];

	public async updateRowCount(dxDataGridComponent: dxDataGrid, grouppedItems: boolean = false): Promise<void> {
		const dataSource: DataSourceLike<any, any> = dxDataGridComponent.option('dataSource');

		if (dataSource) {
			getDataSourceFilteredAndSortedData(
				dxDataGridComponent,
				(data) => {
					
					// if (this._items && this._items.length > 0) {
					// 	this._items = this._items;
					// } else { 
					// 	dxDataGridComponent.getDataSource().store().load().then((data) => {
					// 		this._items = data as any[]; 
					// 	});
					// }

					const filterExpr = dxDataGridComponent.getCombinedFilter(true)
					dxDataGridComponent.getDataSource().store().load({ filter: filterExpr }).then((data) => {
						this._items = data as any[]; 
						//console.log('********this._items***********', this._items);
					});

					const visibleRows: Row<any, any>[] = dxDataGridComponent.getVisibleRows();

					let rowIndexAwaitsInitialization: boolean = true;
					if (this._items!=null && this._items !=undefined) {

						for (let a = 0; a < this._items.length; a++) {
							const element = this._items[a];

							element.__rowIndex = a;

							if (grouppedItems && rowIndexAwaitsInitialization && visibleRows.length > 0 && visibleRows[0].data.key === element.key) {
								this._rowIndex = a;
							}
						}

						if (visibleRows.length > 0) {

							// We do this update on a second call of `onContentReady` because for some reason dx-data-grid is calling it twice and we have to do this operation on a second call - otherwise it shows incorrect visible rows count.
							if (this._update) {
								dxDataGridComponent.getScrollable().scrollTo(10);

								setTimeout(() => {
									dxDataGridComponent.getScrollable().scrollTo(0);
								}, null);

								this._update = false;
							}

							if (grouppedItems) {
								if (this._totalCount === -1) {
									this._totalCount = (this._items ? this._items.length : 0);
								}
							} else {
								// If total count changed - we scroll up and down to correct the rowCountText because of an internal bug of dx-data-grid where it returns incorrect visible rows count upon loading data for the first time.
								if (this._totalCount !== (this._items ? this._items.length : 0)) {
									this._totalCount = (this._items ? this._items.length : 0);

									this._update = true;
								}

								this._rowIndex = visibleRows[0].data.__rowIndex;
							}
						}
						 if(this._items.length == 0) {this._totalCount=0;}
						this.rowCountText = `${visibleRows.length > 0 ? this._rowIndex + visibleRows.length : 0} / ${this._totalCount}`;
					} else {
						this.rowCountText = '0 / 0';
					}
				}
			);
		}
	}

	private _coreService: CoreService = ServiceLocator.injector.get(CoreService);


}
